import { Avatar, Divider, List, Skeleton } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import "./patientList.scss";
import "moment/locale/tr";
import {
  clearGroup,
  setAllDataSelected,
  setCurrentStep,
  setSearch,
  setSelectItem,
} from "../../../../redux/slices/searchSlice";
import { useNavigate } from "react-router-dom";
import { emptyDescription } from "../../../../redux/slices/fileUploadSlice";
import { setIsEdit } from "../../../../redux/slices/PageSlice";
import _ from "lodash";

const PatientList = () => {
  const searchData = useSelector((state) => state.searchSlice.search);
  const searchSlice = useSelector((state) => state.searchSlice);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSearch([]));
  }, []);
  const navigate = useNavigate();
  const selectItem = (item) => {
    setLoading(true);
    dispatch(setIsEdit(false));
    dispatch(setSelectItem(item));
    dispatch(setCurrentStep(3));
    dispatch(emptyDescription());
    dispatch(setAllDataSelected({}));
    dispatch(clearGroup());
    setLoading(false);
    navigate("/select-patient/request-form");
  };

  return (
    <div
      id="scrollableDiv"
      className="duration-300 border overflow-auto h-80 p-4 mt-4"
    >
      <InfiniteScroll
        dataLength={searchData}
        loader={
          <Skeleton
            paragraph={{
              rows: 1,
            }}
            active
          />
        }
        endMessage={
          <Divider plain>
            {searchData.length > 0
              ? "Hastalarınız bu kadar 🙁. Yeni hasta eklemeyi deneyin."
              : "Hastalarınızı bulamadık. 🙁 Yukarıdan kişi seçmeyi deneyebilirsiniz."}
          </Divider>
        }
        scrollableTarget="scrollableDiv"
      >
        <List
          locale={{
            emptyText: <> Hiç hastanız yok.</>,
          }}
          dataSource={searchData}
          renderItem={(item) => (
            <List.Item onClick={() => selectItem(item)} key={item.idAnimal}>
              <List.Item.Meta
                className="cursor-pointer hover:opacity-70"
                avatar={
                  item.idAnimalType === 1 ? (
                    <Avatar src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg" />
                  ) : (
                    <Avatar src="https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/02/322868_1100-800x825.jpg" />
                  )
                }
                title={item.name}
                description={
                  item.birthDate
                    ? moment(item.birthDate).locale("tr").format("LL")
                    : "Doğum tarihi girilmedi."
                }
              />

              <div className="text-blue-500 font-semibold cursor-pointer">
                Hastayı Seç
              </div>
            </List.Item>
          )}
        />
        {!_.isEmpty(searchSlice.selectedUser) ? (
          <div className="flex items-center justify-center">
            <button
              type="button"
              onClick={() => {
                setLoading(true);
                dispatch(setIsEdit(false));
                dispatch(setCurrentStep(2));
                dispatch(emptyDescription());
                dispatch(setAllDataSelected({}));
                dispatch(clearGroup());
                dispatch(setIsEdit(false));
                dispatch(setSelectItem(null));
                setLoading(false);
                navigate("/select-patient/request-form");
              }}
              className="text-blue-500 font-semibold cursor-pointer hover:opacity-50"
            >
              Yeni hasta oluştur
            </button>
          </div>
        ) : null}
      </InfiniteScroll>
    </div>
  );
};
export default PatientList;
